import { Avatar, Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { AppContext } from "../../../../store/genesys.context";
import StyledMinimizedChatPopUp from "../../../atoms/minimizedChatPopUp.styled";
import AvatarMia from "../../../../assets/images/mia-kreis.png";
import FA__CloseIcon from "../../../../assets/icons/xmark-regular-full.svg";
import StyledCloseIcon from "../../../atoms/icons/closeIcon.styled";
import { POPUP_MEASURE_ATTRIBUTE } from "../../../../iframe/hostBridge";

const MinimizedChatPopUp = (): React.JSX.Element => {
  const {
    setShowMinimizeBotPopup,
    handleMinimizeBot,
  }: {
    setShowMinimizeBotPopup: React.Dispatch<React.SetStateAction<boolean>>;
    handleMinimizeBot: () => void;
  } = React.useContext(AppContext);

  const handleOnClick = () => {
    localStorage.setItem("showMinimizeBotPopup", JSON.stringify(false));
    setShowMinimizeBotPopup(false);
  };

  const handleOpenChatKeyDown = (
    event: React.KeyboardEvent<HTMLDivElement>,
  ) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleMinimizeBot();
    }
  };

  return (
    // The attribute lets the iframe host bridge measure this popup — its height
    // depends on the copy, and the iframe has to be sized to fit it.
    <StyledMinimizedChatPopUp {...{ [POPUP_MEASURE_ATTRIBUTE]: "" }}>
      <IconButton
        aria-label="Popup schließen"
        onClick={handleOnClick}
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          zIndex: 9999,
        }}
      >
        <StyledCloseIcon src={FA__CloseIcon} alt="close" />
      </IconButton>

      <Box
        onClick={handleMinimizeBot}
        onKeyDown={handleOpenChatKeyDown}
        role="button"
        tabIndex={0}
        aria-label="Chat öffnen"
        sx={{
          display: "flex",
          gap: "16px",
          cursor: "pointer",
          flexDirection: "column",
          padding: "16px",
        }}
      >
        <Avatar alt="Mia" src={AvatarMia} />

        {/* headline */}
        <Typography
          variant="body1"
          color="initial"
          sx={{
            fontWeight: "700",
            fontSize: "1.3125rem",
            letterSpacing: "1%",
            color: (theme) => theme.palette.primary.main,
            lineHeight: "16px",
          }}
        >
          Chatte mit uns!
        </Typography>

        {/* text */}
        <Typography
          color="initial"
          sx={{
            color: (theme) => theme.palette.text.primary,
            fontSize: "0.875rem",
          }}
        >
          Hallo, hast du Fragen zu unseren Kursen? Ich berate dich gerne!
        </Typography>
      </Box>
    </StyledMinimizedChatPopUp>
  );
};

export default MinimizedChatPopUp;
